import { fileGetAllDescription as description } from './description';
import { getAll as execute } from './execute';

export { description, execute };
